export default __webpack_public_path__ + "static/img/normal_hijab_pic.ae5208f.svg";